import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import actions from './actions'
import classnames from 'classnames'

class Login extends Component {

  static propTypes = {
    hasError: PropTypes.bool.isRequired,
    errorType: PropTypes.number,
    errorMessage: PropTypes.string,
    location: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired,
    route: PropTypes.object.isRequired,
  }

  constructor (props) {
    super(props)
  }

  render () {
    const { auth } = this.props
    return (<div>
            {auth.login()}
        </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isFetching: state.auth.isFetching,
    hasError: state.auth.hasError,
    errorType: state.auth.errorType,
    errorMessage: state.auth.errorMessage,
    location: ownProps.location,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    login: actions.login,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)
